import {
  type slate,
  type EditorPlugin,
  HtmlSerializer,
  type DocumentValue,
} from '@aha-app/aha-editor-v2';

export type ValueChangeCallbackOptions =
  | {
      format: 'html';
      onChange: (html: string) => void;
    }
  | {
      format: 'json';
      onChange: (value: DocumentValue) => void;
    };

const ValueChangeCallbackPlugin = (
  options: ValueChangeCallbackOptions
): EditorPlugin => {
  let serializer: HtmlSerializer;
  let editor: slate.Editor;

  const { format, onChange } = options;

  function serializeEditor() {
    setImmediate(() => {
      if (format === 'html') {
        const html = serializer.serialize();
        onChange(html);
      } else {
        // Make a copy to ensure we don't share the internal data
        const { children, metadata } = editor;
        const value = JSON.parse(
          JSON.stringify({ children, metadata })
        ) as DocumentValue;

        onChange(value);
      }
    });
  }

  return {
    name: 'ValueChangeCallbackPlugin',

    handlers: {
      onInit(ahaEditor) {
        editor = ahaEditor.editor;
        serializer = new HtmlSerializer(ahaEditor.editor);

        serializeEditor();
      },

      onChange() {
        serializeEditor();
      },
    },
  };
};

export default ValueChangeCallbackPlugin;
